import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=f9f46714&"
import script from "./CustomersView.vue?vue&type=script&lang=ts&"
export * from "./CustomersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports